import React from "react";
import "./projects.css";

const Projects = () => {
  const projects = [
    {
      name: "Njoro Girls High School",
      location: "Nakuru",
      description:
        "Supplied and installed 120 CCTV cameras campus-wide with 24/7 monitoring system. Provided 50 laptops for computer lab upgrade.",
      logo: "NJ",
      image:
        "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1751612936/NJONJO-HIGH_nkyhxz.png",
    },
    {
      name: "Radiance Academy",
      location: "",
      description:
        "Complete security solution including access control systems, burglar alarms, and 60 high-definition CCTV cameras with night vision.",
      logo: "RA",
      image:
        "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1751613024/download_epxbnh.png",
    },
    {
      name: "Rift Valley Institute of Science and Technology",
      location: "(RVIST)",
      description:
        "Network infrastructure overhaul with 30 enterprise routers, 8 server racks, and campus-wide fiber optic cabling installation.",
      logo: "RV",
      image:
        "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1751613098/download_1_b3efgn.png",
    },
    {
      name: "AGRico Potato Services Africa",
      location: "",
      description:
        "Warehouse security system with thermal cameras, motion sensors, and alarm system integrated with mobile monitoring.",
      logo: "AG",
      image:
        "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1751613324/download_2_obfawv.png",
    },
    {
      name: "Total Petrol Station",
      location: "Naivasha",
      description:
        "Fuel station security package including license plate recognition cameras, POS systems, and emergency alarm triggers.",
      logo: "TP",
      image:
        "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1751613369/download_hduxux.jpg",
    },
    {
      name: "Anester High School",
      location: "Nakuru",
      description:
        "Smart classroom setup with 40 tablets, charging carts, and teacher workstations plus network infrastructure.",
      logo: "AN",
      image:
        "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1751613406/download_1_pytgxz.jpg",
    },
    {
      name: "Think Twice Kenya",
      location: "(Baltic Textile)",
      description:
        "Industrial security system with 45 explosion-proof cameras for textile factory environment and access control systems.",
      logo: "TT",
      image:
        "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1751613446/download_2_rppng6.jpg",
    },
  ];

  return (
    <section
      aria-label="Our Completed Projects"
      className="projects-section"
      itemScope
      itemType="https://schema.org/ItemList"
    >
      <div className="projects-header">
        <h1 itemProp="name">Our Security & IT Installations</h1>
        <p className="subheading">
          Trusted by leading institutions for CCTV, networking, and security
          solutions
        </p>
      </div>

      <div className="projects-grid">
        {projects.map((project, index) => (
          <article
            key={`project-${index}`}
            className="project-card"
            itemScope
            itemProp="itemListElement"
            itemType="https://schema.org/ListItem"
          >
            <div className="project-image-container">
              {project.image ? (
                <img
                  src={project.image}
                  alt={`${project.name} security installation`}
                  className="project-image"
                  loading="lazy"
                />
              ) : (
                <div className="image-placeholder">
                  <span className="project-logo">{project.logo}</span>
                </div>
              )}
            </div>
            <div className="project-content">
              <h2 itemProp="name">
                <span className="project-name">{project.name}</span>
                {project.location && (
                  <span className="project-location">{project.location}</span>
                )}
              </h2>
              <p className="project-description" itemProp="description">
                {project.description}
              </p>
              <div className="services-tags">
                <span className="service-tag">CCTV</span>
                <span className="service-tag">Networking</span>
                <span className="service-tag">Security</span>
              </div>
            </div>
            <meta itemProp="position" content={index + 1} />
          </article>
        ))}
      </div>
    </section>
  );
};

export default Projects;
